import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  template: `
    <span class="relative inline-block group">
      <ng-content />
      @if (text()) {
        <span
          class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 pointer-events-none
                 opacity-0 group-hover:opacity-100 transition-opacity
                 whitespace-nowrap rounded bg-primary-dark text-white text-xs px-2 py-1 z-50"
          role="tooltip"
        >
          {{ text() }}
        </span>
      }
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  text = input('');
}
